module.exports = __webpack_public_path__ + "static/img/hdw12.de86088e.jpg";